import type { JourneyData } from "../utils/types"

export const useJourneyStore = defineStore("journey", {
  state: (): {
    journeyData: JourneyData | null
  } => ({
    journeyData: null
  }),
  getters: {
    getJourneyData(): JourneyData | null {
      return this.journeyData
    }
  },
  actions: {
    setJourneyData(data: JourneyData): void {
      this.journeyData = data
    }
  }
})
